
import ListV3 from './components/ListV3';

export default {
  i18nComponentKey: 'WidgetProductReviewsListV3.WidgetProductReviewsListV3Pc',
  name: 'WidgetProductReviewsListV3Pc',
  components: { ListV3 }
};
